import axios from "axios"
import { LOADER_STATUS, PROFILE_INFO, SET_FILING_STATUS, STORE_DROPDOWN_GSTIN, STORE_ENTITY, STORE_GSTIN, STORE_PERIOD } from "./constants"
import { getLocalStorage } from "components/Helper/Helper"
import { Config } from '../../Config.js';
import { errorToastMessage } from "utils/errorToast";

export function loader(status){
  return{
      type: LOADER_STATUS,
      loaderStatus: status
  }
}
export function profileInfo(payload){
    return{
      type: PROFILE_INFO,
      profileData: payload
    }
}
export function storeSelectedEntity(payload){
    return{
      type: STORE_ENTITY,
      selectedEntity: payload
    }
}
export function storeSelectedGstin(payload){
    return{
      type: STORE_GSTIN,
      selectedGstin: payload
    }
}
export function setPeriodStore(payload){
    return{
      type: STORE_PERIOD,
      selectedPeriod: payload
    }
}
export function setFilingStatus(payload){
    return{
      type: SET_FILING_STATUS,
      filingStatus: payload
    }
}
export const getProfile = (value) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        profileId: value
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gst/get_profile`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            let sortedGstin = [];
            if(response.data.error != 1){
              sortedGstin = response.data.profileInfo.sort((a, b) =>
              a.gstin > b.gstin ? 1 : -1
            );
              dispatch(profileInfo(sortedGstin));
            }
          
             dispatch(loader(false))
            resolve(sortedGstin);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }

  export function fetchEntityList(){
    return (dispatch) => {
      dispatch(loader(true));
      let data = {
        user_id:getLocalStorage("user_id").user_id
      };
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}console/getCompanyByUserId`,
          data,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        })
          .then((response) => {
            if (response.data.error != 1) {
              let entityList = response.data.data.map((entity)=>{
                return {value:entity.company_id, label:entity.name}
              });
              // dispatch(setEntityList(entityList));
              console.log("res data entity lis",response.data)
              resolve(entityList);
            }else{
              resolve([]);
            }
            dispatch(loader(false));
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
          });
      });
    }
  };

  export const getGstinByEntity = (value) => {
    console.log(value);
    return (dispatch) => {
      dispatch(loader(true));
      let data = {
        entity_id: value,
        user_id:getLocalStorage("user_id").user_id,
        profile_type: "GST"
  
      };
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}console/getGstnListByEntityId`,
          data: data,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        })
          .then((response) => {
            if (response.data.error != 1) {
  
  
              const gstinList = (response.data?.data || []).filter(
                (item) => item?.profile_type === "GST"
              );
              if(gstinList.length > 0){
                console.log(gstinList,"data in console")
                  const sortedGstin = gstinList.sort((a, b) =>
                  a.gstin > b.gstin ? 1 : -1
                  );
                  // dispatch(profileInfo(sortedGstin));
                  resolve(sortedGstin);
              }else{
                // dispatch(profileInfo([]));
                resolve([]);
              }
            }
  
            dispatch(loader(false));
            resolve(true);
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
          });
      });
    };
  };

  export function getFilingStatus(gstin, ret_period, entity){
    return (dispatch) => {
      dispatch(loader(true));
      let data = {
        gstin, ret_period, entity
      };
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}gstR6/getFillingStatus`,
          data,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
        })
          .then((response) => {
            if (response.data.error != 1) {
              dispatch(setFilingStatus(response.data.data[0].fileStatus));
            }else{
              errorToastMessage(response.data.message);
            }
            dispatch(loader(false));
            resolve(true);
          })
          .catch((error) => {
            dispatch(loader(false));
            console.log(error);
            reject(true);
          });
      });
    }
  };